<template>
    <div class="industry">
        <nav-head :bg="false"></nav-head>
        <div class="ban-bg">
            <img src="~assets/images/product/txt-int.png">
        </div>
        <div class="introduction">
            <div class="guide">
                <div class="title">
                    <h3>政策引导</h3>
                    <div class="guide-info">
                        政策落实，引导查重行业规模化、扩大化发展
                    </div>
                </div>
                <div class="guide-txt">
                    <div>
                        《教育部国家发展改革委财政部关于深化研究生教育改革的意见》、
                        《博士硕士学位论文抽检办法》、《国务院学位委员会关于印发&lt;学士学位授权与授予管理办法&gt;的通知》
                        等相关法律法规已出具明确论文检查规定及必要性说明,进一步实现高等教育内涵式发展。
                    </div>
                    <div>
                        2019年2月22日, 教育部公布今年的工作要点,将强化对学术不端行为的监督查处,并要开展硕士博士学位论文抽检等工作; 
                        5天后,教育部发文表示，<span>对学位论文作假行为露头即查、一 查到底、 有责必究,实现“零容忍”。</span>
                    </div>
                </div>
            </div>
            <div class="guide">
                <div class="title">
                    <h3>痛点解决</h3>
                    <div class="guide-info">
                        专项解决不同群体在论文查重过程中遇到的问题
                    </div>
                </div>
                <table>
                    <thead class="thead">
                    <tr>
                        <td>人群</td>
                        <td>现状</td>
                        <td>目的</td>
                    </tr>
                    </thead>
                    <tbody class="tbody">
                    <tr>
                        <td>本科生</td>
                        <td>东拼西凑，临时抱佛脚，资金不充裕</td>
                        <td>找稳定、价格便宜的平台</td>
                    </tr>
                    <tr>
                        <td>硕博生</td>
                        <td>看重科研成果，担心论文泄露</td>
                        <td>找安全性高的口碑平台</td>
                    </tr>
                    <tr>
                        <td>学术投稿</td>
                        <td>相评职称提待遇，但怕投稿文章退稿延误评选</td>
                        <td>找具备行业权威的平台</td>
                    </tr>
                    </tbody>
                </table>
                <div class="guide-txt">
                    <div>
                        毕业论文查重结果关系到是否授予或撤销学士学位,期刊投稿论文查重结果关系到文章是否被杂志社录用,
                        职称能否正常评选。因此,论文检测对于个人发展而言至关重要。
                    </div>
                </div>
            </div>
            <div class="guide">
                <h3>无限前景</h3>
                <div class="guide-info">
                    逐年递增的市场规模<i></i>
                </div>
                <div class="guide-txt">
                    <div>
                        随着国家对学位作假行为的重视，各高校纷纷引入学术不端检测系统严查学位论文作假。学生为确保论文通过，
                        会自行在网上找查重系统进行自查。在这种情况下，
                        <span>每年产生了上千万人的自查市场</span>从而形成了现在的论文查重市场。
                        据调查<span>每个毕业生一篇论文一般至少检测3次以上。
                        </span>2022年保守估计至少<span>15亿以上的市场，</span>且大学生每年以<span>5%的比例在递增，
                        </span>这一市场还在逐步扩大，对于一个轻资产公司服务的垂直市场，利润空间非常诱人。
                    </div>
                </div>
                <div class="guide-info">
                    未来市场有望扩大十倍<i></i>
                </div>
                <div class="guide-txt">
                    <div>
                        未来，中国的教育也将向西方先进国家市场看齐,
                        查重需求将从高校毕业生延伸到初高中生，
                        届时<span>查重市场规模将激增10倍以上。</span>
                    </div>
                </div>
            </div>
        </div>
        <back-top></back-top>
        <footer-version></footer-version>
    </div>
</template>

<script>
    import {NavHead,FooterVersion,BackTop} from "../components";
    import {linkRefresh} from "../common/mixin";

    export default {
        name: "Industry",
        components: {
            NavHead,
            FooterVersion,
            BackTop
        },
        mixins:[linkRefresh]
    }
</script>

<style scoped lang="less">
    .ban-bg {
        background-image: url("~assets/images/product/ban-int.jpg");
        img {
            height: 86px;
        }
    }
    .introduction {
        background: #e8e8e8;
        padding-bottom: 5px;
        .guide {
            background: #fff;
            padding: 30px 50px;
            margin-bottom: 30px;
            &:nth-child(2n){
                .title {
                    text-align: right;
                    font-size: 0;
                    .guide-info {
                        display: inline-block;
                    }
                }
            }
            h3 {
                font-size: 72px;
                color: #4a96cf;
                margin-bottom: 20px;
            }
            .guide-info {
                font-size: 24px;
                font-weight: bold;
                color: #fff;
                background: #4a96cf;
                padding: 10px 20px;
                width: 560px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                i {
                    display: inline-block;
                    height: 0;
                    width: 0;
                    border-top: 18px solid #fff;
                    border-left: 12px solid transparent;
                    border-right: 12px solid transparent;
                    border-bottom: 18px solid transparent;
                    position: absolute;
                    top: 15px;
                    right: 40px;

                }
            }
            .guide-txt {
                padding: 10px 0;
                div {
                    text-indent: 3em;
                    padding: 10px 0;
                    line-height: 30px;
                }
                font-size: 20px;
                color: #333333;
                span {
                    color: #4a96cf;
                }
            }
            table {
                color: #fff;
                border-spacing: 2px;
                text-align: center;
                font-size: 20px;
                padding-top: 20px;
                border-spacing: 0 5px;
                td {
                    background: #b5b6b6;
                    padding: 15px 12px;
                }
                td:first-child {
                    background: #9fa0a0;
                    width: 114px;

                }
                td:nth-child(2){
                    border-left: 5px solid #fff;
                    border-right: 5px solid #fff;
                }
                td:last-child {
                    background: #f2911d;
                    width: 236px;
                }
                .thead >tr >td {
                    font-weight: bold;
                }
                .tbody > tr > td {
                }
            }
        }
    }
</style>